module.exports = __webpack_public_path__ + "img/Technology Partner-3.10f11173.png";